<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big"><strong>FIFTY YEARS OF<br/> PSYCHICAL RESEARCH</strong></span></p>
<p class="center"><span class="big1"><strong>A CRITICAL SURVEY</strong></span><br/><br/><br/></p>
<p class="center"><em>By</em><br/>
<strong>HARRY PRICE</strong></p>
<p class="center"><em>Honorary Secretary, University of London<br/> Council for Psychical Investigation</em><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?49f04708